import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  max-width: 1640px;
  margin: 0 auto;
  padding: 98px clamp(18px, 3vw, 52px) 64px;
  color: ${p => p.theme.palette.colors.text};
  animation: analyticsReveal 0.34s ease both;

  @keyframes analyticsReveal { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
  @media (max-width: 600px) { padding-top: 84px; }
`

export const Header = styled.header`
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;
  @media (max-width: 720px) { align-items: flex-start; flex-direction: column; }
`

export const HeaderCopy = styled.div`max-width: 720px;`
export const HeaderTools = styled.div`display: flex; flex: 0 0 auto; align-items: center; gap: 12px; @media (max-width: 480px) { width: 100%; > * { width: 100%; } }`
export const PageTitle = styled.h1`margin: 0; font: 700 clamp(30px, 4vw, 48px)/1.08 Poppins, sans-serif; letter-spacing: -0.04em;`
export const PageDescription = styled.p`margin: 10px 0 0; color: ${p => p.theme.palette.colors.muted}; font: 400 14px/1.65 Poppins, sans-serif;`

export const SectionContext = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 8px;
  @media (max-width: 700px) { display: block; }
`
export const SectionTitle = styled.h2`margin: 0; font: 700 24px/1.25 Poppins, sans-serif; letter-spacing: -0.025em;`
export const SectionDescription = styled.p`max-width: 740px; margin: 0; color: ${p => p.theme.palette.colors.subdued}; font: 400 13px/1.55 Poppins, sans-serif; @media (max-width: 700px) { margin-top: 6px; }`

export const State = styled.section`
  display: grid;
  min-height: 300px;
  align-content: center;
  justify-items: start;
  gap: 10px;
  padding: 34px 0;
  border-block: 1px solid ${p => p.urgent ? p.theme.palette.error.main : p.theme.palette.colors.borderSoft};
`
export const StateTitle = styled.h2`margin: 0; font: 700 22px/1.3 Poppins, sans-serif;`
export const StateText = styled.p`max-width: 620px; margin: 0; color: ${p => p.theme.palette.colors.muted}; font: 400 14px/1.6 Poppins, sans-serif;`
export const StateAction = styled.button`
  min-height: 42px;
  margin-top: 8px;
  padding: 9px 16px;
  border: 0;
  border-radius: 8px;
  background: ${p => p.theme.palette.blue.main};
  color: ${p => p.theme.palette.blue.contrastText};
  font: 600 13px Poppins, sans-serif;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 2px; }
`
export const DataQualityNote = styled.p`margin: 0 0 20px; color: ${p => p.theme.palette.warning.main}; font: 500 12px/1.5 Poppins, sans-serif;`
